import { SelectBox } from '@/components/inputs/SelectBox'

import type { FilterType } from '../../base/FilterableTable/FilterableTable.types'

type Props = {
  onFilterSelect: (value: FilterType) => void
  selectedOptions?: FilterType[]
  width?: string | number
  label: string
  options: FilterType[]
}

export const SelectFilter = ({ label, onFilterSelect, options, selectedOptions, width }: Props) => (
  <SelectBox
    label={label}
    options={options?.filter(
      (opt) => !selectedOptions?.some((selectedOption) => selectedOption.value === opt.value)
    )}
    getOptionId={(option) => `${option.value}`}
    value={null}
    formatInputOption={(option) => option.label ?? option.value}
    onChange={(value) => onFilterSelect(value)}
    sx={{
      width: width ?? 125
    }}
  />
)
